import { useState, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';

import { ToastProvider } from '@/components/ui';
import { createQueryClient } from '@/lib/query';

import { AuthProvider } from './AuthProvider';

export interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Order matters: auth sits above the query client so a sign-out can reset the cache, and the
 * toast region sits innermost so any provider below it can surface a message.
 */
export function AppProviders({ children }: AppProvidersProps) {
  // Created once per mount rather than at module scope: a module-level client would be shared
  // across tests and leak one case's cache into the next.
  const [queryClient] = useState(createQueryClient);

  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>{children}</ToastProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
}
